import { render } from "./GallabLogo.vue?vue&type=template&id=c0277260"
import script from "./GallabLogo.vue?vue&type=script&lang=js"
export * from "./GallabLogo.vue?vue&type=script&lang=js"

import "./GallabLogo.vue?vue&type=style&index=0&id=c0277260&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__